<template>
  <div class="container" @mousedown="navigate(link)">
    <div class="content">
      <i :class="icon" class="fa icon" aria-hidden="true"></i>
      <div class="description" v-html="decodeData(description)"/>
    </div>
    <div class="right-arrow">
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationCard',
  props: ['description', 'icon', 'link'],
  methods: {
    navigate (link) {
      this.$bvModal.hide("good-morning-modal");
      this.$router.push(link);
    },
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #E0E5F5;
  border-radius: 10px;
  padding: 25px;
  gap: 5px;
  cursor: pointer;
}

.content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.icon {
  font-size: 4rem;
  color: #604AFF;
}

.right-arrow {
  text-align: center;
  color: #FFF;
  border-radius: 100px;
  background-color: #604AFF;

  .fa {
    font-size: 2.2rem;
    padding: 14px 16px;
  }
}

.description {
  font-size: 20px;
  max-width: 480px;
}
</style>